import type { ReactNode } from "react";

import { cx } from "class-variance-authority";

import * as theme from "./PageNavMenuPanel.css";

export type PanelSide = "left" | "right";

export interface PageNavMenuPanelProps {
    collapsed: boolean;
    /** `right` is the wider details panel beside the content. */
    side?: PanelSide;
    id?: string;
    children: ReactNode;
}

export function PageNavMenuPanel({
    collapsed,
    side = "left",
    id,
    children,
}: PageNavMenuPanelProps) {
    return (
        <div
            id={id}
            className={cx(
                theme.root,
                theme.sides[side],
                collapsed && theme.collapsedRoot
            )}
            inert={collapsed}
            aria-hidden={collapsed}
        >
            {children}
        </div>
    );
}
